export function serializeQueryParams(params: Record<string, any>): string {
    const searchParams = new URLSearchParams();

    Object.entries(params).forEach(([key, value]) => {
        if (value === undefined || value === null) return;

        if (Array.isArray(value)) {
            value.forEach((item) => {
                searchParams.append(key, String(item));
            });
        } else {
            searchParams.append(key, String(value));
        }
    });

    return searchParams.toString(); // e.g., ?foo=1&bar=2&tags=a&tags=b
}
